import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/sass/affiliate.scss";

// Icons
const CheckIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
);
const ChevronRight = () => (
  <svg
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
);
const DollarSign = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
    />
  </svg>
);
const Zap = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 10V3L4 14h7v7l9-11h-7z"
    />
  </svg>
);
const TrendingUp = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
    />
  </svg>
);
const ShieldCheck = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const AffiliateLanding = () => {
  const [referrals, setReferrals] = useState(10);
  const avgOrderValue = 3000000;
  const commissionRate = 0.3;
  const estimatedEarnings = referrals * avgOrderValue * commissionRate;

  return (
    <div className="aff-landing-page">
      {/* Navbar */}
      <nav className="landing-nav">
        <div className="nav-container">
          <Link to="/" className="brand">
            <img
              src="/assets/img/logo-horizontal.svg"
              alt="VMASS Partner"
              style={{ height: "40px" }}
            />
            <span className="brand-suffix">Partner</span>
          </Link>
          <div className="nav-links">
            <a href="#benefits">Lợi ích</a>
            <a href="#how-it-works">Cách hoạt động</a>
            <a href="#calculator">Thu nhập</a>
            <a href="#faq">FAQ</a>
            <Link to="/login">Đăng nhập</Link>
            <Link to="/signup" className="btn-cta">
              Đăng ký ngay
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1>
            Hợp tác cùng <span className="highlight">VMASS</span>
            <br />
            Kiến tạo thu nhập bền vững
          </h1>
          <p>
            Tham gia chương trình đối tác affiliate uy tín nhất lĩnh vực phần
            mềm quản lý bán hàng. Nhận hoa hồng trọn đời lên đến 30% cho mỗi
            khách hàng bạn giới thiệu.
          </p>
          <div className="hero-buttons">
            <Link to="/signup" className="btn btn-primary">
              Trở thành Đối tác ngay
            </Link>
            <a href="#calculator" className="btn btn-secondary">
              Tính toán lợi nhuận
            </a>
          </div>
        </div>
      </section>

      {/* Benefits - Bento Grid */}
      <section id="benefits" className="section">
        <div className="container">
          <div className="section-header">
            <h2>Tại sao chọn VMASS?</h2>
            <p>Nền tảng tốt nhất để tối ưu hóa thu nhập của bạn</p>
          </div>
          <div className="features-grid">
            <div className="feature-card col-span-2">
              <div className="icon">
                <DollarSign />
              </div>
              <h3>Hoa hồng trọn đời 30%</h3>
              <p>
                Khác với các nền tảng khác chỉ trả hoa hồng lần đầu, VMASS cam
                kết chia sẻ lợi nhuận trọn đời mỗi khi khách hàng gia hạn dịch
                vụ. Thu nhập của bạn sẽ tích lũy và tăng trưởng theo thời gian.
              </p>
            </div>
            <div className="feature-card bg-dark">
              <div className="icon">
                <Zap />
              </div>
              <h3>Thanh toán siêu tốc</h3>
              <p>
                Rút tiền 24/7 về mọi ngân hàng tại Việt Nam. Không giam vốn,
                không chờ đợi xét duyệt thủ công lâu la.
              </p>
            </div>
            <div className="feature-card bg-grad">
              <div
                className="icon"
                style={{ background: "rgba(255,255,255,0.2)", color: "white" }}
              >
                <TrendingUp />
              </div>
              <h3>Công nghệ Tracking 4.0</h3>
              <p>
                Hệ thống tracking real-time minh bạch. Ghi nhận chính xác từng
                click, từng đơn hàng dù khách hàng mua sau 30 ngày.
              </p>
            </div>
            <div className="feature-card col-span-2">
              <div className="icon">
                <ShieldCheck />
              </div>
              <h3>Hỗ trợ tận tâm 1-1</h3>
              <p>
                Đội ngũ support riêng biệt cho Partner. Bạn được cung cấp tài
                liệu marketing, landing page mẫu và banner quảng cáo chuyên
                nghiệp để dễ dàng tiếp cận khách hàng.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="how-it-works" className="section steps-section">
        <div className="container">
          <div className="section-header">
            <h2>Quy trình hợp tác</h2>
            <p>Đơn giản hoá hành trình kiếm tiền của bạn chỉ với 3 bước</p>
          </div>
          <div className="steps-container">
            <div className="step-item">
              <div className="step-number">1</div>
              <h3>Đăng ký tài khoản</h3>
              <p>
                Điền thông tin đăng ký trong 30 giây. Xét duyệt tự động và cấp
                quyền truy cập Dashboard ngay lập tức.
              </p>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <h3>Chia sẻ liên kết</h3>
              <p>
                Lấy link giới thiệu duy nhất của bạn và chia sẻ nó qua mạng xã
                hội, website, blog hoặc chạy quảng cáo.
              </p>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <h3>Nhận hoa hồng</h3>
              <p>
                Theo dõi thu nhập tăng lên mỗi ngày và rút tiền về tài khoản
                ngân hàng bất cứ khi nào bạn muốn.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Calculator */}
      <section id="calculator" className="section aff-calculator-section">
        <div className="container">
          <div className="section-header">
            <h2>Ước tính thu nhập</h2>
            <p>
              Xem tiềm năng thu nhập của bạn dựa trên số lượng khách hàng giới
              thiệu
            </p>
          </div>
          <div className="aff-calc-box">
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                <span>Khách hàng / tháng</span>
                <span style={{ color: "#059669", fontSize: "24px" }}>
                  {referrals}
                </span>
              </div>
              <input
                type="range"
                min="1"
                max="100"
                value={referrals}
                onChange={(e) => setReferrals(parseInt(e.target.value))}
                className="aff-range"
              />
            </div>

            <div className="aff-result-box">
              <p
                style={{
                  fontSize: "14px",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  opacity: 0.9,
                }}
              >
                Thu nhập ước tính
              </p>
              <div className="aff-result-amount">
                {estimatedEarnings.toLocaleString("vi-VN")} đ
              </div>
              <p style={{ fontSize: "14px", opacity: 0.9 }}>
                / tháng (Tích lũy trọn đời)
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="section">
        <div className="container">
          <div className="section-header">
            <h2>Câu hỏi thường gặp</h2>
            <p>Giải đáp những thắc mắc phổ biến nhất</p>
          </div>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Tôi có cần trả phí tham gia không?</h4>
              <p>
                Hoàn toàn không. Chương trình đối tác của VMASS là hoàn toàn
                miễn phí tham gia.
              </p>
            </div>
            <div className="faq-item">
              <h4>Khi nào tôi được thanh toán?</h4>
              <p>
                Bạn có thể yêu cầu rút tiền bất cứ lúc nào khi số dư khả dụng
                đạt tối thiểu 200.000đ. Tiền sẽ về tài khoản trong vòng 24h.
              </p>
            </div>
            <div className="faq-item">
              <h4>Cookie được lưu bao lâu?</h4>
              <p>
                Chúng tôi áp dụng chính sách Cookie 30 ngày. Nghĩa là khách hàng
                click vào link của bạn và mua hàng trong vòng 30 ngày sau đó,
                bạn vẫn được tính hoa hồng.
              </p>
            </div>
            <div className="faq-item">
              <h4>Tôi có thể chạy quảng cáo từ khóa tên thương hiệu không?</h4>
              <p>
                Không. Chúng tôi nghiêm cấm hành vi chạy quảng cáo Search Ads
                với từ khóa thương hiệu "VMASS". Bạn có thể chạy các từ khóa
                chung khác.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Sẵn sàng bùng nổ thu nhập?</h2>
          <p>
            Gia nhập cộng đồng hơn 5.000 đối tác thành công cùng VMASS ngay hôm
            nay.
          </p>
          <Link to="/signup" className="btn-glow">
            Đăng ký Affiliate Ngay
          </Link>
        </div>
      </section>

      <footer>
        <div className="container">
          &copy; 2026 VMASS Software. All rights reserved. • Chính sách bảo mật
          • Điều khoản sử dụng
        </div>
      </footer>
    </div>
  );
};

export default AffiliateLanding;
